import cartDropdownHtml from './cartdropdown.component.html';

class CartDropdownController {
    constructor($scope, cartService, CheckoutService) {
        'ngInject';

        this.$scope = $scope;
        this.isOpen = false;
        this.service = cartService;
        this.checkout = CheckoutService;
    }

    get productsValue() {
        if (this.checkout.loaded) {
            return this.checkout.summary.net_value_of_products_with_discount.toFixed(2).toString().replace('.', ',');
        } else if (this.service.loaded) {
            return this.service.summary.toFixed(2).toString().replace('.', ',');
        } else {
            return this.cartSum;
        }
    }

    open() {
        this.isOpen = true;
    }

    close() {
        this.isOpen = false;
    }

    toggle() {
        this.isOpen = !this.isOpen;
    }

    $onInit() {
        this.$scope.clickOutside = () => {
            if (!this.isOpen) return;

            this.isOpen = false;
            this.$scope.$apply();
        };
    }
}

let cartDropdownComponent = {
    bindings: {
        count: '@',
        shopId: '@',
        cartSum: '@',
        currencySymbol: '@',
        currencySymbolPlacement: '@'
    },
    template: cartDropdownHtml,
    controller: CartDropdownController
}

export default cartDropdownComponent;
